import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { WithdrawalRequest } from "../../../../Transfer/models/transfer.model";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { AddNewWithdrawalRequest } from "../models/withdrawalRequest.model";
import { addNewResponseWithdrawalRequestService } from "../services/withdrawalRequest.service";
import { formatDateResponse } from "../../../../../utilities/dateFormat";
import { ToastControlBackendModel } from "../../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

interface Props {
  ActuallyResponseDatarow: WithdrawalRequest;
  setDialogWithResponse: (data: boolean) => void;
  getAllWithdrawalRequestData: () => void;
  setMessageBackend: (value: ToastControlBackendModel) => void;
}

function FormAddNewResponseRequest({
  ActuallyResponseDatarow: ActuallyResponseDataRow,
  setDialogWithResponse,
  getAllWithdrawalRequestData,
  setMessageBackend,
}: Props): JSX.Element {
  const [responseNewWithdrawalRequest, setResponseNewWithdrawalRequest] = useState<string>("");
  const [dateResponse, setDateResponse] = useState<Nullable<Date>>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data: AddNewWithdrawalRequest = {
        idUser: ActuallyResponseDataRow.user ? ActuallyResponseDataRow.user?.idUser : 0,
        idLottery: ActuallyResponseDataRow.idLottery,
        dateWithdrawalRequest: formatDateResponse(String(ActuallyResponseDataRow.dateWithdrawalRequest)),
        responseWithdrawalRequest: responseNewWithdrawalRequest,
        dateResponse: dateResponse
          ? formatDateResponse(dateResponse?.toISOString().split("T")[0])
          : new Date().toISOString().split("T")[0],
      };

      const response = await addNewResponseWithdrawalRequestService(data);
      if (response) {
        setDialogWithResponse(false); 
        getAllWithdrawalRequestData(); 
      }
    } catch (error) {
      setMessageBackend({
        severityValue: "error",
        detailValue: "Error al registrar respuesta",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    } finally {
      setMessageBackend({
        severityValue: "success",
        detailValue: "Respuesta registrada con éxito",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    }
  };

  return (
    <form className="flex flex-column gap-3" onSubmit={onSubmit}>
      <div className="w-full">
        <InputText
          className="w-full"
          type="text"
          placeholder="Agregar una nueva respuesta..."
          value={responseNewWithdrawalRequest}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setResponseNewWithdrawalRequest(e.target.value)}
          autoFocus
        />
      </div>
      <div className="w-full">
        <Calendar
          id="dateEndLottery"
          value={dateResponse}
          onChange={(e) => setDateResponse(e.value)}
          dateFormat="yy-mm-dd"
          placeholder="Fecha de la respuesta (Opcional)"
          className="w-full"
          showIcon
        />
      </div>
      <Button
        className="text-white w-full"
        label="Responder e Historial"
        type="submit"
        disabled={responseNewWithdrawalRequest.trim().length <= 2}
      />
    </form>
  );
}

export default FormAddNewResponseRequest;